export default class Api {
   static API_URL = '/wp-json/api/v1'
   static REVIEW_URI = Api.API_URL + '/get-review'
   static SUBSCRIBE_URI = Api.API_URL + '/subscribe'
   static COMPARE_ALL_DATA = Api.API_URL + '/compare/getAllData'

   static sendRequest = (URL, body, method, headers = {}) => {
      return fetch(URL, {
         method,
         headers: {
            'Content-Type': 'application/json',
            ...headers,
         },
         body: JSON.stringify(body),
      })
         .then(response => response.json())
   }

   static sendPostRequest = (URL, body, headers) =>
      Api.sendRequest(URL, body, 'POST', headers)

   static requestReviewById = id =>
      Api.sendPostRequest(Api.REVIEW_URI, {id})

   static requestSubscribe = (email, name = '') =>
      Api.sendPostRequest(Api.SUBSCRIBE_URI, {email, name, page: window.location.href})

   static requestCompareAllData = () =>
      Api.sendPostRequest(Api.COMPARE_ALL_DATA, {})
}